<template>
    <div class="pop_overlay_black" v-show="isShow">
        <div class="pop_wrap rsv_block_add loading_top_wrap" style="width: 455px">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                    r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">{{ $t('popup_reservation_block.title') }}</span>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <div class="pop_desc lgray black_txt" style="border-bottom: 1px solid var(--gray60)">
                {{ $t('popup_reservation_block.sub_title') }}
            </div>
            <div class="pop_cont">
                <div class="start_date">{{ this.selectedDate.format($t('popup_reservation_block.date_format')) }}</div>
                <hr />
                <div class="form_list_wrap">
                    <div class="form_list">
                        <div class="title">{{ $t('popup_reservation_block.label_start') }}</div>
                        <div class="cont">
                            <select class="input_xs" v-model="startHour">
                                <option v-for="(h, index) in 24" :value="h - 1" :key="index">
                                    {{ formatTime(h - 1) }}
                                </option>
                            </select>
                            <select class="input_xs" v-model="startMinute">
                                <option v-for="(m, index) in 12" :value="(m - 1) * 5" :key="index">
                                    {{ formatTime((m - 1) * 5) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form_list">
                        <div class="title">{{ $t('popup_reservation_block.label_end') }}</div>
                        <div class="cont">
                            <select class="input_xs" v-model="endHour" @change="action_ChangeTime">
                                <option v-for="(h, index) in 24" :value="h - 1" :key="index">
                                    {{ formatTime(h - 1) }}
                                </option>
                            </select>
                            <select class="input_xs" v-model="endMinute" @change="action_ChangeTime">
                                <option v-for="(m, index) in 12" :value="(m - 1) * 5" :key="index">
                                    {{ formatTime((m - 1) * 5) }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <small class="red_txt" v-if="isErrorMessage">종료시간은 시작시간과 같거나 이전으로 설정할 수 없습니다.</small>
                <hr />
                <div class="form_list">
                    <div class="title">{{ $t('popup_reservation_block.label_repeat') }}</div>
                    <div class="cont">
                        <select class="w_full input_xs" v-model="routineType">
                            <option value="0">{{ $t('popup_reservation_block.label_do_not_repeat') }}</option>
                            <option value="1">{{ $t('popup_reservation_block.label_every_day') }}</option>
                            <option value="2">{{ $t('popup_reservation_block.label_every_week') }} {{ dayOfWeek }}</option>
                            <option value="3">{{ $t('popup_reservation_block.label_every_month') }} {{ weekOfMonthString }} {{ dayOfWeek }}</option>
                            <option value="4" v-if="isWeekFive">{{ $t('popup_reservation_block.label_every_month') }} {{ $t('popup_reservation_block.label_every_last') }} {{ dayOfWeek }}</option>
                            <option value="5">{{ $t('popup_reservation_block.label_every_monday_friday') }}</option>
                            <option value="6">{{ $t('popup_reservation_block.label_every_monday_saturday') }}</option>
                        </select>
                    </div>
                </div>
                <hr />
                <div class="form_list">
                    <div class="title">{{ $t('popup_reservation_block.label_end_repeat') }}</div>
                    <div class="cont">
                        <div>
                            <label class="radio_wrap">
                                <input type="radio" :value="false" v-model="hasEndDate" />
                                <span class="checkmark"></span>
                                {{ $t('popup_reservation_block.label_no_end_date') }}
                            </label>
                        </div>
                        <div class="mgt_10">
                            <label class="radio_wrap">
                                <input type="radio" :value="true" v-model="hasEndDate" :disabled="routineType == 0" />
                                <span class="checkmark"></span>
                                {{ $t('popup_reservation_block.label_set_end_date') }}
                            </label>
                            <span class="input_date mgl_10">
                                <span class="sheet_weeks_picker_wrap">
                                    <input
                                        type="text"
                                        :disabled="!isRoutine"
                                        class="input_xs"
                                        readonly
                                        @click="action_ShowDatePicker"
                                        @click.stop="action_ShowDatePicker"
                                        v-model="endDate"
                                    />
                                    <v-icon class="ico_date" :disabled="!isRoutine" @click="action_ShowDatePicker"
                                            @click.stop="action_ShowDatePicker">mdi-calendar-blank</v-icon>
                                </span>
                                <v-date-picker
                                    v-if="isShowDatePicker"
                                    v-model="endDate"
                                    :locale="hospitalLocale"
                                    color="#1F8FE5"
                                    width="265px"
                                    :min="minDate"
                                    :max="'2099-12-31'"
                                    :day-format="(date) => new Date(date).getDate()"
                                    @input="action_HideDatePicker"
                                >
                                </v-date-picker>
                            </span>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="form_list">
                    <div class="title">{{ $t('popup_reservation_block.label_memo') }}</div>
                    <div class="cont">
                        <textarea 
                            class="w_full" 
                            cols="30" 
                            rows="5" 
                            :placeholder="$t('popup_reservation_block.placeholder_memo')" 
                            :maxlength="200"
                            v-model="note" 
                        />
                    </div>
                </div>
            </div>
            <div class="btn_wrap">
                <button class="btn btn_blue btn_l" @click="action_Save">{{ $t('popup_reservation_block.button_save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import moment from '@/util/MPMoment'
import { closeReservationBlockPopup, hideCellMenu, sheetOverlays, showBlockRepeatOptionPopup } from '../../../sheet-overlays'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters, selectedColumns, selectedGroups } from '../../../sheet-filters'
import { useV2ReservationBlockCreateMutation } from '@/composables/queries/v2reservationblock/use-v2-reservationblock-create-mutation'
import { useV2ReservationBlockUpdateMutation } from '@/composables/queries/v2reservationblock/use-v2-reservationblock-update-mutation'

export default {
    setup() {
        const { mutateAsync: createReservationBlock } = useV2ReservationBlockCreateMutation()
        const { mutateAsync: updateReservationBlock } = useV2ReservationBlockUpdateMutation()
        return { createReservationBlock, updateReservationBlock }
    },
    props: {
        selectedAreaHelper: Object
    },
    data() {
        return {
            sheetOverlays,
            sheetAxis,
            sheetFilters,
            defaultMoment: moment(),

            originalReservationBlock: undefined,
            hasEndDate: false,
            isLoading: false,
            isErrorMessage: false,
            isShowDatePicker: false,

            startHour: '',
            startMinute: '',
            endDate: undefined,
            endHour: '',
            endMinute: '',
            routineType: 0,
            isRoutine: false,
            note: '',

            range: undefined
        }
    },
    watch: {
        isShow: {
            immediate: true,
            handler: function (newValue) {
                if (!newValue) {
                    this.resetData()
                    this.removeEventListener()
                } else {
                    this.addEventListener()
                    this.range = this.selectedAreaHelper.selectedRange
                }
            }
        },
        reservationBlock: {
            handler: function (newValue) {
                this.originalReservationBlock = deepCopy(newValue)
                if (newValue != undefined) {
                    this.note = newValue.note
                    if (newValue.isRoutine && newValue.endDate != undefined) {
                        if (newValue.endDate == '2099-12-31') {
                            this.hasEndDate = false
                            this.endDate = moment(this.selectedDate).format('YYYY-MM-DD')
                        } else {
                            this.hasEndDate = true
                            this.endDate = moment(newValue.endDate).format('YYYY-MM-DD')
                        }
                    }
                    this.routineType = this.getParsedRoutineType(newValue)
                } else {
                    this.endDate = moment(this.selectedDate).format('YYYY-MM-DD')
                }
            }
        },
        startTime: {
            handler: function (newValue) {
                if (!newValue) return
                this.startHour = newValue.hour()
                this.startMinute = newValue.minute()
            }
        },
        endTime: {
            handler: function (newValue) {
                if (!newValue) return
                this.endHour = newValue.hour()
                this.endMinute = newValue.minute()
            }
        },
        routineType: {
            handler: function (newValue) {
                if (newValue == 0) {
                    this.hasEndDate = false
                    this.isRoutine = false
                } else {
                    this.isRoutine = true
                }
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowReservationBlockPopup
        },
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        reservationBlock: function () {
            return this.sheetOverlays.selectedReservationBlock
        },
        isUpdating: function () {
            return this.reservationBlock != undefined
        },
        minDate: function () {
            return moment(this.selectedDate).format('YYYY-MM-DD')
        },
        timeInterval: function () {
            return this.sheetAxis.selectedTimeInterval
        },
        timeArray: function () {
            return this.sheetAxis.timeArray
        },
        startTime: function () {
            if (!this.isUpdating) {
                let index = Math.min(this.range.start.y, this.range.end.y)
                if (!Number.isNaN(index)) {
                    let time = this.timeArray[index].time
                    return moment(time)
                }
            }
            if (!this.reservationBlock?.startedAt) {
                return this.defaultMoment
            }
            return moment(this.reservationBlock.startedAt)
        },
        endTime: function () {
            if (!this.isUpdating) {
                let index = Math.max(this.range.start.y, this.range.end.y)
                if (!Number.isNaN(index)) {
                    let time = this.timeArray[index].time
                    return moment(time).add(this.timeInterval, 'minutes')
                }
            }
            if (!this.reservationBlock?.endedAt) {
                return this.defaultMoment
            }
            return moment(this.reservationBlock.endedAt)
        },
        dayOfWeek: function () {
            return moment(this.selectedDate).format('dddd')
        },

        weekOfMonth: function () {
            let dayOfMonth = moment(this.selectedDate).date()
            return Math.ceil(dayOfMonth / 7)
        },
        isWeekFive: function () {
            return this.weekOfMonth == 5
        },
        weekOfMonthString: function () {
            let weeks = [
                this.$t('popup_reservation_block.label_first'), 
                this.$t('popup_reservation_block.label_second'), 
                this.$t('popup_reservation_block.label_third'), 
                this.$t('popup_reservation_block.label_fourth')
            ]
            let index = this.isWeekFive ? 2 : 1
            return weeks[this.weekOfMonth - index]
        },
        filteredColumns: function () {
            let groups = deepCopy(selectedGroups())

            return groups
                .sort((l, r) => l?.order ?? 0 - (r?.order ?? 0))
                .reduce((acc, group) => {
                    let ids = selectedColumns().filter((c) => c.isSelected && c.groupID == group._id)

                    acc.push(ids.length > 0 ? ids : { _id: undefined })
                    return acc
                }, [])
                .flat()
        },
        selectedColumnIds: function () {
            let start = Math.min(this.range.start.x, this.range.end.x)
            let end = Math.max(this.range.start.x, this.range.end.x)
            return this.filteredColumns
                .slice(start, end + 1)
                .filter((c) => c._id != undefined)
                .map((c) => c._id)
        }
    },
    methods: {
        // MARK: - Private
        resetData() {
            this.isRoutine = false
            this.routineType = 0
            this.note = ''
            this.isErrorMessage = false
            this.endDate = moment(this.selectedDate).format('YYYY-MM-DD')
        },
        formatTime(value) {
            return value < 10 ? '0' + value : value
        },
        getRoutineTimeUnit() {
            if (this.routineType == '1') {
                return 'daily'
            } else if (this.routineType == '2' || this.routineType == '5' || this.routineType == '6') {
                return 'weekly'
            } else if (this.routineType == '3' || this.routineType == '4') {
                return 'monthly'
            } else {
                return undefined
            }
        },
        getRoutineWeekDays() {
            if (this.routineType == '1') {
                return [0, 1, 2, 3, 4, 5, 6]
            } else if (this.routineType == '2' || this.routineType == '3' || this.routineType == '4') {
                return [moment(this.selectedDate).day()]
            } else if (this.routineType == '5') {
                return [1, 2, 3, 4, 5]
            } else if (this.routineType == '6') {
                return [1, 2, 3, 4, 5, 6]
            } else {
                return undefined
            }
        },
        getRoutineWeekOfMonth: function () {
            let isMonthly = this.getRoutineTimeUnit() == 'monthly'
            let routine = ['first', 'second', 'third', 'fourth']
            if (this.routineType == 4) {
                return 'last'
            }
            let index = this.isWeekFive ? 2 : 1
            return isMonthly ? routine[this.weekOfMonth - index] : undefined
        },
        getParsedRoutineType(block) {
            switch (block.routineTimeUnit) {
                case 'daily': {
                    return 1
                }
                case 'weekly': {
                    let weekDays = block.routineWeekDays
                    if (weekDays.length == 1) return 2
                    if (weekDays.length == 6) return 5
                    else return 6
                }
                case 'monthly': {
                    if (block.routineWeekOfMonth != 'last') return 3
                    else return 4
                }
                default:
                    return 0
            }
        },
        isDiffRepeatOption() {
            let originalBlock = this.originalReservationBlock
            let originalRoutineType = this.getParsedRoutineType(originalBlock)
            let isDiffType = this.routineType != originalRoutineType
            let end = this.hasEndDate ? this.endDate : '2099-12-31'
            let isDiffEndDate = originalBlock.endDate != end

            return isDiffType || isDiffEndDate
        },
        showBlockRepeatOptionPopupPromise(diffRepeatOption) {
            return new Promise((resolve) => {
                showBlockRepeatOptionPopup(diffRepeatOption, (type) => {
                    let response = { editRange: type }
                    if (type == 'current') {
                        response.endDate = moment(this.selectedDate).format('YYYY-MM-DD')
                    }
                    resolve(response)
                })
            })
        },
        // MARK: - Action
        action_ChangeTime() {
            this.isErrorMessage = false
        },
        action_ShowDatePicker() {
            this.isShowDatePicker = true
        },
        action_HideDatePicker() {
            this.isShowDatePicker = false
        },
        action_ClosePopup() {
            hideCellMenu()
            closeReservationBlockPopup()
        },
        async action_Save() {
            let m = moment()
            let start = m.clone().set({ hour: this.startHour, minute: this.startMinute })
            let end = m.clone().set({ hour: this.endHour, minute: this.endMinute })
            if (end.isSameOrBefore(start)) {
                this.isErrorMessage = true
                return
            }
            let response
            if (this.originalReservationBlock?.isRoutine == true) {
                response = await this.showBlockRepeatOptionPopupPromise(this.isDiffRepeatOption())
            }
            await this.requestCreateOrUpdateReservationBlock(response)
        },
        // MARK: - Event
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        },
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                this.action_ClosePopup()
            }
        },
        // MARK: - Network
        async requestCreateOrUpdateReservationBlock(repeatOptionParam) {
            try {
                if (this.isLoading) return
                this.isLoading = true
                let params = {
                    _id: this.originalReservationBlock?._id,
                    hospitalID: this.hospital.selectedHospital._id,
                    columns: this.reservationBlock?.columns ?? this.selectedColumnIds,
                    isRoutine: this.isRoutine,
                    routineTimeUnit: this.getRoutineTimeUnit(),
                    routineRepeatNum: this.isRoutine ? this.reservationBlock?.routineRepeatNum ?? 1 : undefined,
                    routineWeekOfMonth: this.getRoutineWeekOfMonth(),
                    routineWeekDays: this.getRoutineWeekDays(),
                    startDate: moment(this.selectedDate).format('YYYY-MM-DD'),
                    endDate: moment(this.hasEndDate ? this.endDate : this.isRoutine ? '2099-12-31' : this.selectedDate).format('YYYY-MM-DD'),
                    startTime: moment().set({ hour: this.startHour, minute: this.startMinute }).format('HH:mm'),
                    endTime: moment().set({ hour: this.endHour, minute: this.endMinute }).format('HH:mm'),
                    note: this.note
                }
                let mergedParam = { ...params, ...repeatOptionParam }

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                await (this.isUpdating ? this.updateReservationBlock(mergedParam) : this.createReservationBlock(params))
                closeReservationBlockPopup()
            } catch (err) {
                console.log('Error processing reservation block creating or updating: ', err)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
